"use client";

import { ReactNode } from "react";
import { apiPlugin, storyblokInit } from "@storyblok/react";

import Footer from "@/components/layouts/Footer";
import TrustSmall from "@/components/layouts/TrustSmall";
import Accreditors from "@/components/layouts/Accreditors";
import Hero from "@/components/Hero";
import Feature from "@/components/Feature";
import ServiceSection from "@/components/ServiceSection";
import QuoteForm from "@/components/QuoteForm";
import Header from "@/components/layouts/Header";
import ReferenceSelector from "@/components/ReferenceSelector";
import TrustedByTopBrands from "@/components/TrustedTopBrands";
import Qualifications from "@/components/Qualifications";
import HeroAnimated from "@/components/HeroAnimated";
import ContactSocial from "@/components/ContactSocial";
import GoogleMap from "@/components/GoogleMap";
import ContactSection from "@/components/ContactSection";
import HeroBlogPost from "@/components/HeroBlogPost";
import BlogIntro from "@/components/BlogIntro";
import BlogContent from "@/components/BlogContent";
import BlogConclusion from "@/components/BlogConclusion";
import BlogAuthor from "@/components/BlogAuthor";
import BlogLearnMore from "@/components/BlogLearnMore";
import FeaturedTop from "@/components/FeaturedTop";
import FeaturedBottom from "@/components/FeaturedBottom";
import WhySection from "@/components/WhySection";
import BenefitSection from "@/components/BenefitSection";
import DifferentTypeSection from "@/components/DifferentSection";
import GetFastQuote from "@/components/GetFastQuote";
import FaqSection from "@/components/FaqSection";
import PenetrationTestingSection from "@/components/PenetrationTestingSection";
import MeetPenTest from "@/components/MeetPenTest";
import FeatureStatisticSection from "@/components/FeatureStatisticSection";
import BannerCaseStudy from "@/components/BannerCaseStudy";
import RelatedResources from "@/components/RelatedResources";
import TabSection from "@/components/TabSection";
import MethodologySection from "@/components/MethodologySection";
import DataProtectionSection from "@/components/DataProtectionSection";
import TopBrandsSection from "@/components/TopBrandsSection";
import CyberEssentialsPackage from "@/components/CyberEssentialsPackage";
import VideoContent from "@/components/VideoContent";
import PackageSection from "@/components/PackageSection";
import AnimatedLogo from "@/components/AnimatedLogo";
import CyberEssentialsPurchases from "@/components/CyberEssentialsPurchases";
import OvsTypeSection from "@/components/OvsTypeSection";
import ReportAuthor from "@/components/ReportAuthor";
import DownloadForm from "@/components/DownloadForm";
import DownloadCardIndustryReports from "@/components/DownloadCardIndustryReports";
import WebinarsHeading from "@/components/WebinarsHeading";
import WebinarsBody from "@/components/WebinarsBody";
import WebinarsExpert from "@/components/WebinarsExpert";
import WebinarsCardSection from "@/components/WebinarsCardSection";
import JargonBusterContent from "@/components/JargonBusterContent";
import TermsContent from "@/components/TermsContent";
import CookiePolicyContent from "@/components/CookiePolicyContent";
import EventDetails from "@/components/EventDetails";
import EventsCardSection from "@/components/EventsCardSection";
import BlogCompBanner from "@/components/BlogCompBanner";
import BlockquoteAuthor from "@/components/BlockquoteAuthor";
import QuoteOneLine from "@/components/QuoteOneLine";
import BlogCompMyth from "@/components/BlogCompMyth";
import ExpertSection from "@/components/ExpertSection";
import PartnerTermsContent from "@/components/PartnerTermsContent";

const components = {
  header: Header,
  footer: Footer,
  accreditation_small_section: TrustSmall,
  accreditation_big_section: Accreditors,
  hero: Hero,
  hero_blog_post: HeroBlogPost,
  feature: Feature,
  service_section: ServiceSection,
  quote_form: QuoteForm,
  reference_selector: ReferenceSelector,
  trusted_by_top_brands: TrustedByTopBrands,
  qualifications: Qualifications,
  hero_animated: HeroAnimated,
  contact_section: ContactSection,
  contact_social: ContactSocial,
  google_map: GoogleMap,
  blog_details: BlogIntro,
  blog_content: BlogContent,
  blog_conclusion: BlogConclusion,
  blog_author: BlogAuthor,
  blog_learn_more: BlogLearnMore,
  featured_top: FeaturedTop,
  featured_bottom: FeaturedBottom,
  why_section: WhySection,
  benefit_section: BenefitSection,
  different_type_section: DifferentTypeSection,
  get_fast_quote: GetFastQuote,
  faq_section: FaqSection,
  penetration_testing_section: PenetrationTestingSection,
  meet_pen_test: MeetPenTest,
  feature_statistic_section: FeatureStatisticSection,
  banner_case_study: BannerCaseStudy,
  related_resources: RelatedResources,
  tab_section: TabSection,
  methodology_section: MethodologySection,
  data_protection_section: DataProtectionSection,
  top_brands_section: TopBrandsSection,
  cyber_essentials_package: CyberEssentialsPackage,
  cyber_essentials_purchases: CyberEssentialsPurchases,
  video_content: VideoContent,
  package_section: PackageSection,
  animated_logo: AnimatedLogo,
  ovs_type_section: OvsTypeSection,
  report_author: ReportAuthor,
  download_form: DownloadForm,
  download_card_section: DownloadCardIndustryReports,
  webinars_heading: WebinarsHeading,
  webinars_body: WebinarsBody,
  webinars_expert_box: WebinarsExpert,
  webinar_card_section: WebinarsCardSection,
  jargon_buster_content: JargonBusterContent,
  terms_content: TermsContent,
  partner_terms_content: PartnerTermsContent,
  cookie_policy_content: CookiePolicyContent,
  event_details: EventDetails,
  events_card_section: EventsCardSection,
  blog_comp_banner: BlogCompBanner,
  blockquote_author: BlockquoteAuthor,
  quote_one_line: QuoteOneLine,
  blog_comp_myth: BlogCompMyth,
  expert_section: ExpertSection,
};

storyblokInit({
  accessToken: process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN,
  use: [apiPlugin],
  bridge: process.env.NEXT_PUBLIC_NODE_ENV === 'development',
  components,
  apiOptions: {
    region: 'eu',
    cache: {
      type: 'none',
      clear: 'auto'
    }
  }
});

interface StoryblokProviderProps {
  children: ReactNode;
}

export default function StoryblokProvider({ children }: StoryblokProviderProps) {
  return children;
}

